import React from 'react';
export function Testimonials() {
  const testimonials = [{
    quote: '"I finally feel like myself again — at 46."',
    name: 'Sarah M.',
    location: '46, Austin TX',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=800&q=80'
  }, {
    quote: '"The brain fog lifted in three weeks. Three weeks."',
    name: 'Priya K.',
    location: '42, Seattle WA',
    image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=800&q=80'
  }, {
    quote: '"My OB-GYN said it was \'just stress.\' Orla said it was perimenopause."',
    name: 'Dana L.',
    location: '49, Chicago IL',
    image: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=800&q=80'
  }];
  return <section className="bg-orla-bone py-16 md:py-32" data-id="element-423">
      <div className="max-w-[1240px] mx-auto px-6" data-id="element-424">
        <h2 className="font-display font-black text-[32px] md:text-[48px] text-orla-ink tracking-tight leading-[1.1] text-center max-w-[720px] mx-auto" data-id="element-425">
          Hear how women are staying in their prime with Orla.
        </h2>

        <div className="mt-12 md:mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 md:overflow-visible overflow-x-auto snap-x snap-mandatory md:snap-none scrollbar-hide" data-id="element-426">
          {testimonials.map((testimonial, idx) => <div key={idx} className="relative rounded-2xl overflow-hidden shadow-lg cursor-pointer transition-transform hover:scale-[1.02] snap-start min-w-[85vw] md:min-w-0" style={{
          aspectRatio: '3/4'
        }} data-id="element-427">
              {/* Background Image */}
              <div className="absolute inset-0 bg-cover bg-center" style={{
            backgroundImage: `url(${testimonial.image})`
          }} data-id="element-428" />

              {/* Gradient Overlay */}
              <div className="absolute inset-0" style={{
            background: 'linear-gradient(to bottom, transparent 50%, rgba(31, 27, 23, 0.85) 100%)'
          }} data-id="element-429" />

              {/* Play Button */}
              <div className="absolute inset-0 flex items-center justify-center" data-id="element-430">
                <div className="w-16 h-16 rounded-full bg-orla-sienna flex items-center justify-center shadow-[0_8px_24px_rgba(155,71,34,0.4)]" data-id="element-431">
                  <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5 text-orla-bone ml-1" data-id="element-432">
                    <path d="M8 5v14l11-7z" data-id="element-433" />
                  </svg>
                </div>
              </div>

              {/* Bottom Content */}
              <div className="absolute bottom-0 left-0 right-0 p-6" data-id="element-434">
                <p className="font-display italic text-[20px] text-orla-bone leading-[1.3]" data-id="element-435">
                  {testimonial.quote}
                </p>
                <div className="mt-3" data-id="element-436">
                  <p className="font-body font-semibold text-[14px] text-orla-saffron" data-id="element-437">
                    {testimonial.name}
                  </p>
                  <p className="font-body text-[13px] text-orla-bone opacity-70" data-id="element-438">
                    {testimonial.location}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}